import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import 'feedback-lite/dist/feedback.css';

import AuthService from '../services/AuthService';
import browserHistory from '../history';
import { getSearchData, getMenuTree } from '../actions/AppActions';
import Navbar from './Navbar';
import UserContainer from './user/UserContainer';

class NavPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isReady: false,
    };
  }

  componentDidMount() {
    // User should be logged in to access children of NavPage
    if (!this.props.loggedIn) {
      AuthService.removeToken();
      browserHistory.push('/login');
      return;
    }

    Promise.all([
      this.props.getSearchData(),
      this.props.getMenuTree(),
    ]).then(() => {

      this.setState({ isReady: true });
    });
  }

  render() {
    const { changePassword } = this.props;

    if (!this.state.isReady) {
      return <div />;
    }

    if (changePassword) {
      return (
        <div id="nav-page">
          <Navbar />
          <UserContainer
            warning="You must reset your password before continuing"
          />
        </div>
      );
    }

    return (
      <div id="nav-page">
        <Navbar />
        {this.props.children}
      </div>
    );
  }
}

NavPage.propTypes = {
  changePassword: PropTypes.bool,
  children: PropTypes.object,
  getMenuTree: PropTypes.func,
  getSearchData: PropTypes.func,
  loggedIn: PropTypes.bool,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ getSearchData, getMenuTree }, dispatch);
}

function mapStateToProps(state) {
  return {
    changePassword: !!state.app.userData.changePassword,
    loggedIn: !!state.app.user.id,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavPage));
